import { atom } from 'recoil';

export const toggleQuickConfig = atom({
    key: 'aws-toggleQuickConfig',
    default: false,
});

export const quickConfigDetails = atom({
    key: 'aws-quickConfigDetails',
    default: undefined,
});

export const defaultVmDataDisk = atom({
    key: 'aws-defaultVmDataDisk',
    default: undefined,
});

export const toggleSspModels = atom({
    key: 'aws-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDiskOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
    },
});

export const isEnvDetailsLoading = atom({
    key: 'aws-isEnvDetailsLoading',
    default: false,
});

export const isDataDiskLoaded = atom({
    key: 'aws-isDataDiskLoaded',
    default: false,
});

export const isConfigDiskFulfilled = atom({
    key: 'aws-isConfigDiskFulfilled',
    default: false,
});

export const defaultOsDiskType = atom({
    key: 'aws-defaultOsDiskType',
    default: undefined,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'aws-isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'aws-orderId',
    default: '',
});

export const isValidOwners = atom({
    key: 'aws-isValidOwners',
    default: {
        isvalidAppOwner: true,
    },
});

export const toggleCurrentServer = atom({
    key: 'aws-toggleCurrentServer',
    default: false,
});

export const CurrentServerDetails = atom({
    key: 'aws-CurrentServerDetails',
    default: null,
});

export const showisExistADGrp = atom({
    key: 'aws-showisExistADGrp',
    default: false,
});

export const sspSubmitOrder = atom({
    key: 'aws-sspOrder',
    default: {
        // Application Section
        appProfile: null,
        drPriority: null,
        entityDetails: null,
        sector: null,
        sectorDetail: null,
        department: null,
        appRegion: null,
        environment: null,
        landingZoneDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,
        appTier: null,
        appTierCode: null,
        vcpus: null,
        vcpusCoreCount: null,
        microService: null,
        microServiceDetails: null,
        microServiceOptionsAvailable: null,

        // Resource Section
        osImage: null,
        awsAccount: null,
        vpcId: null,
        subnetId: null,
        isSubnetIpExhausted: false,
        securityGroup: null,
        availabilityZone: null,
        ec2InstanceType: null,
        quantity: 1,
        maxDataDiskCount: 8,
        dataDisksCount: null,
        dataDisks: [],
        defaultDataDisks: [],
        vmType: 'Windows',
        retiringServerSysId: null,
        retiringServerName: null,
        disposalReason: null,
        scheduledRetirement: null,
        serverRefresh: 'no',
        billingEntity: null,
        billingEntityDetails: null,
        customBuild: null,
        customBuildDetails: null,

        // Application Component Security Group Section
        componentName: null,
        componentNameDetails: null,

        // Access Management Section
        domain: null,
        adGroup: null,
        adous: null,
        adousDetails: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'aws-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'aws-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'aws-isValidProvisioningForm',
    default: false,
});
